(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-accordion-video')) {
    class ProductAccordionVideo extends HTMLElement {
      constructor() {
        super();
        this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.handlePause = this.handlePause.bind(this);
        this.handleError = this.handleError.bind(this);
        this.handleLoadedMetadata = this.handleLoadedMetadata.bind(this);
        this.handleQualityToggleClick = this.handleQualityToggleClick.bind(this);
        this.handleQualityOptionClick = this.handleQualityOptionClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        this.video = this.querySelector('video');
        this.playButton = this.querySelector('.product-accordion-video__play');
        if (!this.video || !this.playButton) return;

        this.qualityToggle = this.querySelector('.product-accordion-video__quality-toggle');
        this.qualityCurrent = this.querySelector('.product-accordion-video__quality-current');
        this.qualityMenu = this.querySelector('.product-accordion-video__quality-menu');
        this.qualityOptions = Array.from(this.querySelectorAll('[data-quality][data-quality-url]'));
        this.loadingIndicator = this.querySelector('.product-accordion-video__loading');
        this.loadingQuality = this.querySelector('.product-accordion-video__loading-quality');
        this.currentQuality = this.dataset.initialQuality || '';
        this.failedQualities = new Set();
        this.isSwitching = false;
        this.switchContext = null;
        this.restoreTimeout = null;
        this.loadGeneration = 0;

        this.playButton.addEventListener('click', this.handlePlayButtonClick);
        this.video.addEventListener('play', this.handlePlay);
        this.video.addEventListener('pause', this.handlePause);
        this.video.addEventListener('ended', this.handlePause);
        this.video.addEventListener('error', this.handleError);
        this.video.addEventListener('loadedmetadata', this.handleLoadedMetadata);

        if (this.qualityToggle && this.qualityMenu && this.qualityOptions.length) {
          this.qualityToggle.addEventListener('click', this.handleQualityToggleClick);
          this.qualityOptions.forEach((option) => option.addEventListener('click', this.handleQualityOptionClick));
          this.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('click', this.handleDocumentClick);
          this.updateQualitySelection(this.currentQuality);
        }

        if (this.video.readyState >= 1 && this.currentQuality) {
          this.failedQualities.delete(this.currentQuality);
        }
      }

      disconnectedCallback() {
        if (!this.video || !this.playButton) return;

        this.playButton.removeEventListener('click', this.handlePlayButtonClick);
        this.video.removeEventListener('play', this.handlePlay);
        this.video.removeEventListener('pause', this.handlePause);
        this.video.removeEventListener('ended', this.handlePause);
        this.video.removeEventListener('error', this.handleError);
        this.video.removeEventListener('loadedmetadata', this.handleLoadedMetadata);

        if (this.qualityToggle) this.qualityToggle.removeEventListener('click', this.handleQualityToggleClick);
        this.qualityOptions.forEach((option) => option.removeEventListener('click', this.handleQualityOptionClick));
        this.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('click', this.handleDocumentClick);
        window.clearTimeout(this.restoreTimeout);
      }

      handlePlayButtonClick() {
        const playPromise = this.video.play();
        if (playPromise) playPromise.catch(() => this.handlePause());
      }

      handlePlay() {
        this.classList.add('is-playing');
      }

      handlePause() {
        this.classList.remove('is-playing');
      }

      handleError() {
        this.handlePause();
        if (!this.qualityOptions.length) {
          this.playButton.disabled = true;
          return;
        }

        const failedQuality = this.isSwitching ? this.switchContext.pendingQuality : this.currentQuality;
        if (failedQuality) this.failedQualities.add(failedQuality);

        if (!this.switchContext) {
          this.switchContext = {
            state: this.capturePlaybackState(),
            originalQuality: null,
            pendingQuality: failedQuality,
            recovering: false
          };
        }

        const originalQuality = this.switchContext.originalQuality;
        if (!this.switchContext.recovering && originalQuality && !this.failedQualities.has(originalQuality)) {
          this.loadQuality(originalQuality, true);
          return;
        }

        const fallback = this.qualityOptions.find((option) => !this.failedQualities.has(option.dataset.quality));
        if (fallback) {
          this.loadQuality(fallback.dataset.quality, true);
          return;
        }

        this.finishSwitch();
        this.playButton.disabled = true;
      }

      handleLoadedMetadata() {
        if (!this.qualityOptions.length) return;

        if (!this.isSwitching || !this.switchContext) {
          this.failedQualities.delete(this.currentQuality);
          this.updateQualitySelection(this.currentQuality);
          return;
        }

        const state = this.switchContext.state;
        this.video.volume = state.volume;
        this.video.muted = state.muted;
        this.video.playbackRate = state.playbackRate;

        const duration = Number.isFinite(this.video.duration) ? this.video.duration : state.currentTime;
        const targetTime = Math.min(state.currentTime, Math.max(duration - 0.1, 0));
        const generation = this.loadGeneration;
        let restoreCompleted = false;
        const completeRestore = () => {
          if (restoreCompleted || generation !== this.loadGeneration || !this.switchContext) return;
          restoreCompleted = true;
          window.clearTimeout(this.restoreTimeout);
          this.currentQuality = this.switchContext.pendingQuality;
          this.failedQualities.delete(this.currentQuality);
          this.updateQualitySelection(this.currentQuality);
          const shouldResume = state.wasPlaying;
          this.finishSwitch();
          if (shouldResume) {
            const playPromise = this.video.play();
            if (playPromise) playPromise.catch(() => this.handlePause());
          } else {
            this.video.pause();
          }
        };

        if (targetTime > 0.05 && Math.abs(this.video.currentTime - targetTime) > 0.05) {
          this.video.addEventListener('seeked', completeRestore, { once: true });
          this.restoreTimeout = window.setTimeout(completeRestore, 1800);
          try {
            this.video.currentTime = targetTime;
          } catch (error) {
            completeRestore();
          }
        } else {
          completeRestore();
        }
      }

      handleQualityToggleClick() {
        if (this.isSwitching) return;
        this.qualityMenu.hidden ? this.openQualityMenu() : this.closeQualityMenu();
      }

      handleQualityOptionClick(event) {
        if (this.isSwitching) return;
        const quality = event.currentTarget.dataset.quality;
        this.closeQualityMenu();
        if (!quality || quality === this.currentQuality) return;

        this.failedQualities.delete(quality);
        this.switchContext = {
          state: this.capturePlaybackState(),
          originalQuality: this.currentQuality,
          pendingQuality: quality,
          recovering: false
        };
        this.loadQuality(quality, false);
      }

      handleDocumentClick(event) {
        if (!this.contains(event.target)) this.closeQualityMenu();
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && !this.qualityMenu.hidden) {
          event.preventDefault();
          this.closeQualityMenu();
          this.qualityToggle.focus();
          return;
        }

        if (this.qualityMenu.hidden || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const focusedIndex = this.qualityOptions.indexOf(document.activeElement);
        let nextIndex = focusedIndex;

        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.qualityOptions.length - 1;
        if (event.key === 'ArrowDown') nextIndex = (focusedIndex + 1 + this.qualityOptions.length) % this.qualityOptions.length;
        if (event.key === 'ArrowUp') nextIndex = (focusedIndex - 1 + this.qualityOptions.length) % this.qualityOptions.length;

        this.qualityOptions[nextIndex].focus();
      }

      capturePlaybackState() {
        return {
          currentTime: Number.isFinite(this.video.currentTime) ? this.video.currentTime : 0,
          wasPlaying: !this.video.paused && !this.video.ended,
          volume: this.video.volume,
          muted: this.video.muted,
          playbackRate: this.video.playbackRate
        };
      }

      loadQuality(quality, recovering) {
        const option = this.qualityOptions.find((item) => item.dataset.quality === quality);
        if (!option || !this.switchContext) return;

        this.isSwitching = true;
        this.loadGeneration += 1;
        this.switchContext.pendingQuality = quality;
        this.switchContext.recovering = recovering;
        window.clearTimeout(this.restoreTimeout);
        this.setLoading(true, quality);
        this.closeQualityMenu();
        this.video.src = option.dataset.qualityUrl;
        this.video.load();
      }

      finishSwitch() {
        this.isSwitching = false;
        this.switchContext = null;
        this.setLoading(false);
      }

      setLoading(isLoading, quality) {
        if (!this.loadingIndicator || !this.qualityToggle) return;
        this.loadingIndicator.hidden = !isLoading;
        this.qualityToggle.disabled = isLoading;
        this.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (quality && this.loadingQuality) this.loadingQuality.textContent = quality;
      }

      openQualityMenu() {
        if (!this.qualityMenu || this.isSwitching) return;
        this.qualityMenu.hidden = false;
        this.qualityToggle.setAttribute('aria-expanded', 'true');
        const selectedOption = this.qualityOptions.find((option) => option.getAttribute('aria-checked') === 'true');
        (selectedOption || this.qualityOptions[0]).focus();
      }

      closeQualityMenu() {
        if (!this.qualityMenu || !this.qualityToggle) return;
        this.qualityMenu.hidden = true;
        this.qualityToggle.setAttribute('aria-expanded', 'false');
      }

      updateQualitySelection(quality) {
        if (!quality || !this.qualityToggle || !this.qualityCurrent) return;
        this.qualityCurrent.textContent = quality;
        this.qualityToggle.setAttribute('aria-label', `${this.video.getAttribute('aria-label')}: ${quality}`);
        this.qualityOptions.forEach((option) => {
          option.setAttribute('aria-checked', option.dataset.quality === quality ? 'true' : 'false');
        });
      }
    }

    customElements.define('product-accordion-video', ProductAccordionVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
